import React, { useState } from "react";
import { makeStyles, Typography, Link as MuiLink, Box, useMediaQuery } from "@material-ui/core";
import Link from "next/link";
import classenames from "classnames";

import Card from "components/header/assets/temporaryCard.svg";

function SubPanelContent({ productTypes, commercialCategories }) {
  const classes = useStyle();
  const isSmall = useMediaQuery("(max-width: 1300px)");
  const [hoveredProduct, setHoveredProduct] = useState(null);

  return (
    <div className={classes.buy}>
      <div className={classes.buyInner}>
        <Typography noWrap component="div">
          <Box color="secondary.main" fontWeight="bold" component="span">
            Nos appareils
          </Box>
        </Typography>
        <Typography noWrap component="div">
          <Box color="secondary.main" fontWeight="bold" component="span">
            Les catégories
          </Box>
        </Typography>
        <div className={classes.productTypesContainer} onMouseLeave={() => setHoveredProduct(null)}>
          {productTypes.map((product) => (
            <div
              key={product.slug}
              onMouseEnter={() => setHoveredProduct(product.slug)}
              className={classes.productSubPanel}
            >
              <Link href={`/reconditionne/${product.slug}`} passHref>
                <MuiLink variant="body1" noWrap underline="none" className={classes.product}>
                  <Box
                    color="secondary.main"
                    className={classenames(
                      { [classes.productHovered]: hoveredProduct === product.slug },
                      { [classes.productGrey]: hoveredProduct && hoveredProduct !== product.slug }
                    )}
                    component="span"
                  >
                    {product.name}
                  </Box>
                </MuiLink>
              </Link>
            </div>
          ))}
        </div>
        <div className={classes.commercialCategoriesContainer}>
          {commercialCategories.map((category) => {
            return (
              <div key={category.name} className={classes.commercialCategoryItem}>
                <img src={category.icon} alt="" />
                <div className={classes.commercialCategoriesText}>
                  <Link href={category.query} passHref>
                    <MuiLink variant="body1" noWrap underline="none">
                      <Box color="grey.900" component="span" className={classes.categoryTitle}>
                        {category.name}
                      </Box>
                    </MuiLink>
                  </Link>
                  <Box color="text.disabled">
                    <Typography className={classes.description}>{category.text}</Typography>
                  </Box>
                </div>
              </div>
            );
          })}
        </div>
        {!isSmall && <div className={classes.divider} />}
      </div>
      {!isSmall ? (
        <MuiLink href="/le-reconditionne">
          <Card />
        </MuiLink>
      ) : (
        <div className={classes.emptyCard} />
      )}
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  emptyCard: {
    width: 282,
    height: 357,
  },
  productHovered: {
    fontWeight: 500,
  },
  product: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  arrow: { marginRight: theme.spacing(4) },
  productGrey: {
    color: theme.palette.text.disabled,
  },
  buy: {
    background: "white",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
  },
  buyInner: {
    display: "grid",
    gridTemplateColumns: "min-content minmax(0, 1fr)",
    width: 750,
    gridColumnGap: theme.spacing(10),
    gridRowGap: theme.spacing(2),
    position: "relative",
    marginRight: theme.spacing(6),
    paddingRight: theme.spacing(6),
  },
  commercialCategoriesContainer: {
    display: "flex",
    flexDirection: "column",
    marginRight: theme.spacing(4),
    paddingTop: theme.spacing(4),
  },
  divider: {
    position: "absolute",
    top: 0,
    bottom: 0,
    width: 1,
    right: 0,
    backgroundColor: "#D1D1D1",
  },
  commercialCategoryItem: {
    display: "grid",
    gridTemplateColumns: "50px 1fr",
    alignItems: "flex-start",
    marginBottom: theme.spacing(4),
  },
  commercialCategoriesText: {
    width: 300,
    display: "grid",
    marginLeft: theme.spacing(2),
    gridRowGap: theme.spacing(0.5),
  },
  description: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    fontSize: 16,
  },
  productSubPanel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
  },
  productTypesContainer: {
    display: "grid",
    gridTemplateColumns: "1fr",
    marginBottom: "auto",
    paddingTop: theme.spacing(2),
  },
}));

export default SubPanelContent;
